<template>
  <div class="row">
    <div class="col-6">
      <div class="d-flex flex-row justify-content-start gap-2 py-2">
        <slot name="filterButtons"></slot>
      </div>
    </div>
    <div v-show="btnRequired" class="col-6" style="text-align: right">
      <div class="d-flex flex-row justify-content-end gap-2 py-2">
        <slot name="filterInput"></slot>
        <input
          type="text"
          v-model="searchText"
          placeholder="Search..."
          class="form-control w-full"
          @input="performSearch"
        />
        <div class="d-flex flex-row justify-content-start gap-2">
          <slot name="addButton"></slot>
        </div>
        <div class="ml-2" style="display: inline-block" v-show="button">
          <button to="#" class="btn btn-warning" @click="handleClick()">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive card">
    <DataTable
    tableStyle="width: 100%;"
      :value="filteredData"
      :paginator="true"
      :rows="rows"
      :rowsPerPageOptions="[rows, 15, 20, 50]"
      class="custom-datatable"
    >
      <slot></slot>
    </DataTable>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { DataTable, Column } from "primevue/datatable";

export default {
  inheritAttrs: false,

  components: {
    DataTable,
    Column,
  },
  props: {
    rows: {
      type: Number,
      required: false,
      default: 5,
    },
    columns: {
      type: Array,
      required: true,
    },
    tableData: {
      type: Array,
      required: true,
    },
    button: {
      type: Boolean,
      default: false,
    },

    btnRequired: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  methods: {
    handleClick() {
      this.$emit("click");
    },
  },

  setup(props) {
    const searchText = ref("");

    const filteredData = computed(() => {
      if (searchText.value !== "") {
        const searchQuery = searchText.value.toLowerCase();
        return props.tableData.filter((row) => {
          return props.columns.some((column) => {
            const fieldValue = row[column.field];
            if (fieldValue && typeof fieldValue === "string") {
              return fieldValue.toLowerCase().includes(searchQuery);
            }
            return false;
          });
        });
      } else {
        return props.tableData;
      }
    });

    const performSearch = () => {
      // Trigger computed property update when search text changes
      searchText.value = searchText.value.trimStart();
    };

    return {
      searchText,
      filteredData,
      performSearch,
    };
  },
};
</script>

<style>
.table-container {
  position: relative;
}

.card {
  border: none;
  border-radius: 10px 10px 10px 10px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.custom-datatable .p-datatable-wrapper {
  border-radius: 10px 10px 0px 0px;
}

.custom-datatable .p-paginator-bottom {
  display: flex;
  flex-direction: row-reverse;
}

</style>